<form class="search-bar" [formGroup]='searchForm'>
  <mat-form-field class="search" floatLabel="never" [ngClass]="{'search-open': searchBox == true}"> 
    <input matInput #searchInput [matAutocomplete]="auto" formControlName="search" placeholder="Search">
  </mat-form-field>
  <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption (optionSelected)="onOptionSelected($event)" [displayWith]="displayFn">
    <mat-option *ngFor="let res of results" [value]="res" >
      <mat-icon matListIcon>directions_boat</mat-icon> <span>{{res.name}}</span>
    </mat-option>
  </mat-autocomplete>
</form>